<template>
  <section>
    <div class="lg:container">
      <h2
        class="py-12 mb-0 leading-10 text-center uppercase font-druk text-display-10 md:text-display-14 tracking-02-em md:leading-14 md:mb-12 text-dark xl:py-20"
      >
        {{ $messages("migrant-handbook.list.title") }}
      </h2>
      <ul class="grid gap-12 list-none">
        <li v-for="(item, index) in list" :key="index">
          <article
            class="grid grid-cols-1 grid-rows-2 text-center bg-light-green lg:grid-cols-2 lg:grid-rows-1 lg:text-left"
          >
            <div
              class="self-center row-start-2 px-4 pt-8 pb-12 lg:py-8 lg:row-start-1 lg:px-19"
            >
              <div
                class="uppercase font-gt-america-extended text-smallest text-middle label"
              >
                {{ item.label }}
              </div>
              <h3
                class="mb-8 font-medium leading-9 text-display-11 font-druk lg:text-display-14 lg:leading-13 uppercase mt-1"
              >
                {{ item.title }}
              </h3>
              <p
                class="font-light leading-snug text-smallest font-gt-america lg:text-base"
              >
                {{ item.body }}
              </p>
              <button
                type="button"
                class="mt-2 btn lg:mx-0 btn-black"
                @click="handleItemCtaClick"
              >
                {{ item.button }}
              </button>
            </div>
            <div class="relative ar-16by9 lg:ar-4by3">
              <img
                draggable="false"
                class="absolute top-0 left-0 object-cover object-center w-full h-full "
                :src="item.image"
                :alt="item.title"
              >
            </div>
          </article>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
function scrollTo (offset, callback) {
  const fixedOffset = offset.toFixed()
  const onScroll = function () {
    if (window.pageYOffset.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll)
      callback()
    }
  }

  window.addEventListener('scroll', onScroll)
  onScroll()
  window.scrollTo({
    top: offset,
    behavior: 'smooth'
  })
}

export default {
  computed: {
    list () {
      const items = this.$messages('migrant-handbook.list.items')
      const images = [
        'https://majority.imgix.net/web-assets/migrant-handbook/VISA.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/SSN.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/HOUSING-kian-lem-s_HqmrMsph8-unsplash.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/HEALTHCARE-hush-naidoo-jade-photography-pA0uoltkwao-unsplash.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/BANKING-different-banks.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/WORKING-jud-mackrill-Of_m3hMsoAA-unsplash.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/EDUCATION-cdc-GDokEYnOfnE-unsplash.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/TAXES-kelly-sikkema-8DEDp6S93Po-unsplash.jpg',
        'https://majority.imgix.net/web-assets/migrant-handbook/LIVING-MAJORITY - sofi perazzo-027.jpg'
      ]
      const listWithImage = Object.keys(items).map((key) => {
        const item = items[key]
        return {
          ...item,
          image: images[key]
        }
      })

      return listWithImage
    }
  },
  methods: {
    handleItemCtaClick () {
      scrollTo(0, () => {
        document.querySelector('.feature-hero-wrapper input').focus()
      })
    }
  }
}
</script>
<style lang="postcss" scoped>
label::after{
  content: counter(article);
}
section {
  counter-reset: article;
  article {
    counter-increment: article;
  }
  .label {
    &:after {
      content: " "counter(article);
    }
  }
}
</style>
